import { render, staticRenderFns } from "./SearchZipModal.vue?vue&type=template&id=24cc35c4&scoped=true&"
import script from "./SearchZipModal.vue?vue&type=script&lang=js&"
export * from "./SearchZipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cc35c4",
  null
  
)

export default component.exports